
        import config, { initConfig } from '/js/config.js';
        
        async function initializeApp() {
            try {
                // Initialize configuration first
                const configData = await initConfig();
                
                // Make config available globally
                window.VITE_SUPABASE_URL = configData.supabaseUrl;
                window.VITE_SUPABASE_ANON_KEY = configData.supabaseAnonKey;
                window.VITE_STRIPE_PUBLIC_KEY = configData.stripeKey;
                
                // Initialize Supabase client
                const { createClient } = supabase;
                window.supabaseClient = createClient(
                    configData.supabaseUrl,
                    configData.supabaseAnonKey,
                    {
                        auth: {
                            autoRefreshToken: true,
                            persistSession: true,
                            detectSessionInUrl: true
                        }
                    }
                );
                
                console.log('Application initialized successfully');
            } catch (error) {
                console.error('Failed to initialize application:', error);
            }
        }
        
        initializeApp();
    